const CubeIcon = () => (
  <svg
    height='18'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M12 2 L22 8 L12 14 L2 8 Z' fill='#aaa' />
    <path d='M2 8 L2 18 L12 24 L12 14 Z' fill='#777' />
    <path d='M12 14 L12 24 L22 18 L22 8 Z' fill='#999' />
  </svg>
);

export default CubeIcon;
